// ------------------------------------
// Formas de pagamento
// ------------------------------------
(function () {
  'use strict';

  // Listas
  const $collapses = $('.payment-accordion');
  const $cardNumber = $('#co-card-number');
  const $cardCVV = $('#co-card-cvv');
  const $cardValidity = $('#co-card-validity');
  const $cardValidityMonth = $('#co-card-validity-month');
  const $cardValidityYear = $('#co-card-validity-year');
  const $cardBrand = $('#co-card-brand');
  const $cardToken = $('#co-card-hash');
  const urlApi = urlBase + 'core/acoes/checkout/parcelamentos.php';
  const $formAddParams = $('.co-add-params');
  const $cardTokenInputsTrigger = $('.card-trigger');
  const $installmentsWrp = $('.installments-wrp');
  const $installments = $('#co-card-installments');
  const $cardName = $('#co-card-name');
  const $cardCPF = $('#co-card-cpf');
  const $cardCustomer = $('#co-name');
  let discount = 0;
  let maxInstallments;
  let maxInstallmentsFree;
  let fee;
  let gateway;
  let cardNumber;
  let cardValidityMonth;
  let cardValidityYear;
  let timerToken;

  // Ao alterar o número do cartão
  $cardNumber.on('change', function () {
    //$installmentsWrp.hide();
    cardNumber = somenteNumeros($cardNumber.val());
    if (cardNumber.length >= 6) {
      getInstallments();
      if (gateway === 'cielo') {
        getCieloCardBin();
      }
    }
  });

  // Ao alterar a validade do cartão
  $cardValidity.on('input', function () {
    if ($(this).val()) {
      const validityArr = $(this).val().split('/');
      cardValidityMonth = validityArr[0] ? validityArr[0] : undefined;
      cardValidityYear = validityArr[1] ? validityArr[1] : undefined;
      if (cardValidityMonth) {
        $cardValidityMonth.val(cardValidityMonth);
      }
      if (cardValidityYear) {
        $cardValidityYear.val('20' + cardValidityYear);
        cardValidityYear = '20' + cardValidityYear;
      }
    }
  });

  // Ao alterar o CPF do titular
  $cardCPF.on('input', function () {
    if ($(this).val()) {
      const docNumber = somenteNumeros($(this).val());
      if ($('#docNumber').length > 0 && docNumber.length > 10) {
        $('#docNumber').val(docNumber).trigger('change');
      }
    }
  });

  // Ao alterar os números para obter o token
  $cardTokenInputsTrigger.on(
    'change',
    debounce(function () {
      if (gateway === 'pagseguro') {
        getPagSeguroCardToken();
      } else if (gateway === 'pagseguroapi') {
        getPagSeguroApiCardToken();
      } else if (gateway === 'mercadopago') {
        getMercadoPagoCardToken();
      } else if (gateway === 'pagarme') {
        getPagarmeCardToken();
      } else if (gateway === 'appmax') {
        getAppmaxCardToken();
      } else if (gateway === 'cielo') {
        getCieloCardToken();
      } else if (gateway === 'rede') {
        getRedeCardToken();
      } else if (gateway === 'cloudfox') {
        getCloudfoxCardToken();
      } else if (gateway === 'nexus') {
        getNexusCardToken();
      } else if (gateway === 'doppus') {
        getDoppusCardToken();
      } else if (gateway === 'abmex') {
        getAbmexCardToken();
      } else if (gateway === 'dom') {
        getDomCardToken();
      } else if (gateway === 'pagouai') {
        getPagouaiCardToken();
      } else if (gateway === 'iugu') {
        getIuguCardToken();
      } else if (gateway === 'tryplopay') {
        //getIuguCardToken();
      } else if (gateway === 'getnet') {
        getNetCardToken();
      }

      // Gateway retry
      if (gatewayRetry === 'cloudfox' || gatewayRetry === 'nexus') {
        getCloudfoxAntifraudToken();
      }
    }, 500),
  );

  // Recarrega as parcelas quando o valor total é alterado
  $installments.on('change-amount', function () {
    cardNumber = somenteNumeros($cardNumber.val());
    if (cardNumber.length >= 6) {
      getInstallments();
    }
  });
  $installments.on('change', function () {
    if ($installments.val()) {
      localStorage.setItem('ci_' + cartToken, $installments.val());
      if (gateway === 'iugu') {
        getIuguCardToken();
      }
    }
  });

  // Exibe a bandeira do cartão com base no número
  $cardNumber.on('input change', function () {
    showCardFlag(somenteNumeros($cardNumber.val()));
  });
  if ($cardNumber.length > 0) {
    showCardFlag(somenteNumeros($cardNumber.val()));
  }
  function showCardFlag(cardNumber) {
    cardNumber = typeof cardNumber === 'number' ? cardNumber.toString() : cardNumber;
    const cardFlag = getCardFlag(cardNumber);
    if (cardNumber.length > 3 && cardFlag) {
      showCardFlagEl(cardFlag);
    } else {
      hideCardFlagEl();
    }
  }
  function showCardFlagEl(cardFlag) {
    const $cardFlag = $('.co-card-number-flag');
    if ($cardFlag.length > 0) {
      const $cardFlagImg = $cardFlag.find('img');
      const pathFlags = coreAssetsPath + 'img/payment/';
      $cardFlagImg.attr('src', pathFlags + cardFlag + '.png');
      $cardFlag.addClass('active');
    }
  }
  function hideCardFlagEl() {
    const $cardFlag = $('.co-card-number-flag');
    if ($cardFlag.length > 0) {
      const $cardFlagImg = $cardFlag.find('img');
      $cardFlagImg.attr('src', '');
      $cardFlag.removeClass('active');
    }
  }

  // Valida o campo de validade do cartão
  window.Parsley.addValidator('cardvalidity', {
    validateString: function (value) {
      const validity = value.trim().split('/');
      const month = validity[0];
      const year = validity[1];
      const monthNumber = Number(month);
      const yearNumber = Number('20' + year);
      const curMonth = new Date().getMonth() + 1;
      const curYear = new Date().getFullYear();
      const monthCompare = yearNumber === curYear ? curMonth : 1;
      return (
        month &&
        month.length === 2 &&
        monthNumber >= monthCompare &&
        monthNumber <= 12 &&
        year &&
        year.length > 1 &&
        yearNumber >= curYear
      );
    },
    messages: {
      'pt-br': 'Data inválida.',
    },
  });

  // Valida o campo de data de nascimento
  window.Parsley.addValidator('birthdate', {
    validateString: function (value) {
      const curYear = new Date().getFullYear();
      const birthdate = value.trim().split('/');
      const day = Number(birthdate[0]);
      const month = Number(birthdate[1]);
      const year = Number(birthdate[2]);
      return day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= curYear - 18;
    },
    messages: {
      'pt-br': 'Digite uma data válida.',
    },
  });

  // Percorre todas as listas
  $collapses.each(function () {
    // Variáveis
    const $collapse = $(this);
    const $itens = $collapse.children('.collapse-item');
    const $itensTitle = $itens.children('.collapse-title');
    const $itensContent = $itens.children('.collapse-content');
    const $checks = $itens.find('.collapse-title input');
    const $inputsAll = $itens.find(
      '.collapse-content input[data-required], .collapse-content select[data-required], .collapse-content textarea[data-required]',
    );
    let itemsActive = 0;
    $itens.each(function () {
      const $item = $(this);
      const $content = $item.find('.collapse-content');
      const $check = $item.find('.collapse-title input');
      const $inputs = $item.find(
        '.collapse-content input[data-required], .collapse-content select[data-required], .collapse-content textarea[data-required]',
      );
      if ($(this).hasClass('active')) {
        itemsActive++;
        disableAll($itens, $itensContent, $checks, $inputsAll);
        activeItem($item, $content, $check, $inputs);
      }
    });

    if (itemsActive === 0) {
      calcCheckout();
    }

    // Evento de click no título do item
    $itensTitle.on('click', function (ev) {
      ev.preventDefault();
      const $item = $(this).parent('.collapse-item');
      const $content = $(this).next('.collapse-content');
      const $check = $item.find('.collapse-title input');
      const $inputs = $item.find(
        '.collapse-content input[data-required], .collapse-content select[data-required], .collapse-content textarea[data-required]',
      );
      if (!$item.hasClass('active')) {
        disableAll($itens, $itensContent, $checks, $inputsAll);
        activeItem($item, $content, $check, $inputs);
      }
    });
  });

  // Habilita um item
  function activeItem($item, $content, $check, $inputs) {
    $item.addClass('active');
    $('.co-orderbump').trigger('reload-position');
    $content.slideDown();
    $check.prop('checked', true).trigger('change').parsley().validate();
    $inputs.prop('disabled', false);
    $inputs.prop('required', true);
    $inputs.each(function () {
      $(this).parsley().reset();
    });
    handlePayment();
    $installments.prop('disabled', true);
    $installmentsWrp.find('.form-help').show();
  }

  // Desabilita um item
  function disableItem($item, $content, $check, $inputs) {
    $item.removeClass('active');
    $content.slideUp();
    $check.prop('checked', false).trigger('change').parsley().validate();
    $inputs.val('');
    $inputs.prop('disabled', true);
    $inputs.prop('required', false);
    $inputs.each(function () {
      $(this).parsley().reset();
    });
  }

  // Desabilita todos os itens
  function disableAll($itens, $contents, $checks, $inputsAll) {
    $itens.removeClass('active');
    $contents.slideUp();
    $checks.prop('checked', false).trigger('change');
    $inputsAll.val('');
    $inputsAll.prop('disabled', true);
    $inputsAll.prop('required', false);
    $inputsAll.each(function () {
      $(this).parsley().reset();
    });
  }

  // Ao selecionar uma forma de pagamento
  function handlePayment() {
    if ($collapses.length > 0 || $('.co-payment-tabs-input').length > 0) {
      const $input =
        $('.payment-item').length > 0
          ? $('.payment-item input[name="payment_method"]:checked')
          : $('.co-payment-tabs-input[name="payment_method"]:checked');
      const method = $input.val();
      const title = $input.data('title');
      discount = Number($input.data('discount'));
      maxInstallments = $input.data('max-installments') ? Number($input.data('max-installments')) : 0;
      maxInstallmentsFree = $input.data('max-installments-free') ? Number($input.data('max-installments-free')) : 0;
      gateway = $input.data('gateway');
      fee = $input.data('fee');
      if (!checkoutStepsEnable) {
        dispatchPaymentInfo();
      }
      saveOption('payment_method', method);
      saveOption('payment_title', title);
      saveOption('payment_discount', discount);
      //saveCheckout('save', {}, calcCheckout);
      calcCheckout();
    }
  }

  // Popula as parcelas
  function populeInstallments(installments) {
    $installments.html('').prop('disabled', false);
    $installments.append(`<option value="" hidden>Selecione</option>`);
    if (installments.length > 0) {
      const saveInstallment = localStorage.getItem('ci_' + cartToken);
      for (let item in installments) {
        if (installments[item].installment <= maxInstallments) {
          let interestFree = installments[item].interestFree;
          if (typeof installments[item].interestFree === 'string' && installments[item].interestFree === 'false') {
            interestFree = false;
          }
          let installmentFreeSufix = '';
          if (interestFree) {
            installmentFreeSufix = installments[item].installment > 1 ? ' sem juros' : ' à vista';
          }
          const selected = saveInstallment == installments[item].installment ? 'selected' : '';
          $installments.append(
            `<option value="${installments[item].installment}" ${selected}>${
              installments[item].installment
            }x de R$ ${formatMoneyBR(installments[item].installment_amount)}${installmentFreeSufix}</option>`,
          );
        }
      }
      if ($installments.val() != '') {
        $installments.parsley().validate();
      }
      //$installmentsWrp.show();
      $installments.prop('disabled', false);
      $installmentsWrp.find('.form-help').hide();
    } else {
      $installments.prop('disabled', true);
      $installmentsWrp.find('.form-help').show();
    }
  }

  // Obtém as parcelas (Simulação)
  function getInstallments() {
    if ($cardNumber.length > 0 && !previewMode) {
      if (cardNumber.length >= 6) {
        $installments.html('').append('<option value="">Aguarde...</option>').prop('disabled', true);
        if (gateway === 'pagseguro') {
          getPagSeguroCardBrand(getPagSeguroInstallments);
        } else if (gateway === 'mercadopago') {
          setMercadoPagoPaymentMethod();
        } else {
          // Realiza a requisição dos dados
          $.getJSON(
            `${urlApi}?gateway=${gateway}&cardNumber=${cardNumber}&maxInstallments=${maxInstallments}&maxInstallmentsFree=${maxInstallmentsFree}&cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}&fee=${fee}&storeId=${baseLanding}&lp_type=${storeModel}`,
            function (installments) {
              if (installments.installments) {
                populeInstallments(installments.installments);
              } else {
                console.log(installments);
                console.log('Não foi possível obter o parcelamento via AJAX.');
              }
            },
          ).fail(function (result) {
            console.log(result);
          });
        }
      }
    }
    if (previewMode) {
      $installments.parsley().reset();
    }
  }

  // Salva o parcelamento para os gateways
  let reqAjaxSaveInstallments = null;
  function saveInstallments(installments) {
    if (reqAjaxSaveInstallments != null) {
      reqAjaxSaveInstallments.abort();
    }
    reqAjaxSaveInstallments = $.ajax({
      type: 'POST',
      url: `${urlApi}?gateway=${gateway}&cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      data: { installments: JSON.stringify(installments) },
    })
      .done(function (result) {
        /* try {
          result = JSON.parse(result);
          if (result.status === 'success') {
            console.log('Parcelamento salvo com sucesso.');
          } else {
            console.log(result);
            console.log('Não foi possível salvar o parcelamento.');
          }
        } catch (error) {
          console.log(result);
          console.log('Não foi possível salvar o parcelamento.');
        } */
      })
      .fail(function (result) {
        if (result.statusText !== 'abort') {
          console.log(result.statusText);
          console.log('Não foi possível salvar o parcelamento.');
        }
      });
  }

  // Valida as informações do cartão
  function validateCardInfos(brand = true) {
    const cardName = $cardName.val();
    const cardCVV = $cardCVV.val();
    const cardBrand = $cardBrand.val();
    if (brand) {
      return (
        cardName != '' &&
        cardNumber &&
        cardNumber.length >= 6 &&
        cardBrand &&
        cardBrand != '' &&
        cardValidityMonth &&
        cardValidityMonth.length === 2 &&
        cardValidityYear &&
        cardValidityYear.length > 1 &&
        cardCVV &&
        cardCVV.length >= 3
      );
    }
    return (
      cardName != '' &&
      cardNumber &&
      cardNumber.length >= 6 &&
      cardValidityMonth &&
      cardValidityMonth.length === 2 &&
      cardValidityYear &&
      cardValidityYear.length > 1 &&
      cardCVV &&
      cardCVV.length >= 3
    );
  }

  // Exibe a mensagem de erro no campo do número do cartão
  function showCardNumberError() {
    $cardNumber.parsley().removeError('card-number-error', {
      updateClass: true,
    });
    $cardNumber.parsley().addError('card-number-error', {
      message: 'Verifique o número do cartão informado.',
      updateClass: true,
    });
  }

  // Oculta a mensagem de erro no campo do número do cartão
  function hideCardNumberError() {
    $cardNumber.parsley().removeError('card-number-error', {
      updateClass: true,
    });
  }

  // ------------------------------------
  // Tabs
  // ------------------------------------
  const $paymentTabs = $('.co-payment-tab');
  const $paymentTabsChecks = $('.co-payment-tabs-input');
  const $paymentTabsContents = $('.co-payment-tabs-content');
  const $paymentTabsInputsAll = $paymentTabsContents.find(
    'input[data-required], select[data-required], textarea[data-required]',
  );
  if ($paymentTabsChecks.length > 0) {
    handleTabPayment();
  }
  $paymentTabs.on('click', function () {
    const flagTab = $(this).data('flag');
    if (flagTab) {
      showCardFlagEl(flagTab.replace('.png', ''));
    }
  });
  $paymentTabsChecks.on('change', handleTabPayment);
  function handleTabPayment() {
    const $inputChecked = $('.co-payment-tabs-input:checked');
    const tabContentID = $inputChecked.attr('id');
    const $tabItem = $('.co-payment-tab[for="' + tabContentID + '"]');
    const $tabContentItem = $('.co-payment-tabs-content[data-tab-content="' + tabContentID + '"]');
    showTabPayment(tabContentID, $tabItem, $tabContentItem);
    if ($inputChecked.length > 0) {
      handlePayment();
    }
  }
  function showTabPayment(tabContentID, $tabItem, $tabContentItem) {
    $paymentTabs.removeClass('active');
    $paymentTabsContents.removeClass('active');
    //$tabItem.addClass('active');
    $tabContentItem.addClass('active');
    $paymentTabsInputsAll.prop('disabled', true);
    $paymentTabsInputsAll.prop('required', false);
    $paymentTabsInputsAll.val('');
    $paymentTabsInputsAll.each(function () {
      $(this).parsley().reset();
    });
    const $contentInputs = $tabContentItem.find('input[data-required], select[data-required], textarea[data-required]');
    $contentInputs.prop('disabled', false);
    $contentInputs.prop('required', true);
    $contentInputs.each(function () {
      $(this).parsley().reset();
    });
  }

  // ------------------------------------
  // Pagseguro Api (Novo)
  // ------------------------------------

  // Gera hash do cartão
  function getPagSeguroApiCardToken() {
    const psaErrorsList = {
      INVALID_NUMBER: 'Número do cartão inválido.',
      INVALID_SECURITY_CODE: 'Código do cartão inválido.',
      INVALID_EXPIRATION_MONTH: 'Mês de validade do cartão inválido.',
      INVALID_EXPIRATION_YEAR: 'Ano de validade do cartão inválido.',
      INVALID_PUBLIC_KEY: 'Chave do PagSeguro inválida!',
      INVALID_HOLDER: 'Nome do titular do cartão inválido.',
    };
    if (validateCardInfos(false)) {
      if ($('[data-psa-key]').length) {
        const pagseguroPublicKey = $('[data-psa-key]').data('psa-key');
        if (pagseguroPublicKey) {
          disableOrderBtn();
          const psaCard = PagSeguro.encryptCard({
            publicKey: pagseguroPublicKey,
            holder: $cardName.val(),
            number: cardNumber,
            expMonth: cardValidityMonth,
            expYear: cardValidityYear,
            securityCode: $cardCVV.val(),
          });
          console.log(psaCard);
          if (!psaCard.hasErrors && psaCard.encryptedCard) {
            $cardToken.val(psaCard.encryptedCard);
          } else if (psaCard.errors.length > 0) {
            const errorMsg = psaErrorsList[psaCard.errors[0].code];
            if (errorMsg) {
              showAlert('Erro', errorMsg, 'danger');
            }
          }
          enableOrderBtn();
        } else {
          console.log('PagSeguro Api: Chave pública não encontrada.');
        }
      }
    }
  }

  // ------------------------------------
  // Pagseguro
  // ------------------------------------

  // Inicia o PagSeguro
  if (typeof PagSeguroDirectPayment != 'undefined') {
    initPagSeguro();
  }
  function initPagSeguro() {
    getPagSeguroSessionID();
  }

  // Obtém o id da sessão
  function getPagSeguroSessionID() {
    const urlSession = urlBase + 'core/acoes/checkout/pagseguro_get_session.php';
    $.getJSON(
      `${urlSession}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      function (result) {
        //console.log(result);
        PagSeguroDirectPayment.setSessionId(result.session_id);
        if ($cardCustomer.val() != '') {
          getPagarmeSenderHash();
        }
      },
    ).fail(function (result) {
      console.log(result);
    });
  }

  // Obtém o senderHash ao preencher o nome
  $cardCustomer.on('change', getPagarmeSenderHash);
  function getPagarmeSenderHash() {
    if (
      typeof PagSeguroDirectPayment != 'undefined' &&
      $cardCustomer.val() != '' &&
      !$('#pagseguro_sender_hash').val()
    ) {
      PagSeguroDirectPayment.onSenderHashReady(function (response) {
        if (response.status == 'error') {
          console.log(response.message);
          return false;
        }
        const senderHash = response.senderHash;
        if ($('#pagseguro_sender_hash').length === 0) {
          $formAddParams.append(
            `<input type="hidden" name="pagseguro_sender_hash" id="pagseguro_sender_hash" value="${senderHash}">`,
          );
        } else {
          $('#pagseguro_sender_hash').val(senderHash);
        }
      });
    }
  }

  // Obtém a bandeira do cartão
  function getPagSeguroCardBrand(callback = null) {
    PagSeguroDirectPayment.getBrand({
      cardBin: cardNumber,
      success: function (response) {
        //console.log(response);
        hideCardNumberError();
        $cardBrand.val(response.brand.name).trigger('change');
        if (callback) {
          callback();
        }
      },
      error: function (response) {
        console.log(response);
        showCardNumberError();
      },
    });
  }

  // Obtém as parcelas do cartão
  function getPagSeguroInstallments() {
    const cardBrand = $cardBrand.val();
    const total = getTotalCheckout();
    const opts = {
      amount: total,
      brand: cardBrand,
      success: function (response) {
        console.log(response);
        let installments = response.installments[cardBrand];
        // Formata as parcelas para o formato utilizado
        let newInstallments = [];
        installments.forEach((item) => {
          newInstallments.push({
            installment: item.quantity,
            amount: item.totalAmount,
            interestFree: item.interestFree,
            installment_amount: item.installmentAmount,
          });
        });
        installments = newInstallments;
        saveInstallments(installments);
        populeInstallments(installments);
      },
      error: function (response) {
        console.log(response);
      },
    };
    // Parcelas sem juros
    if (maxInstallmentsFree && maxInstallmentsFree > 1) {
      opts.maxInstallmentNoInterest = maxInstallmentsFree;
    }
    PagSeguroDirectPayment.getInstallments(opts);
  }

  // Obtém o token do cartão
  function getPagSeguroCardToken() {
    const cardCVV = $cardCVV.val();
    const cardBrand = $cardBrand.val();
    if (validateCardInfos()) {
      disableOrderBtn();
      const opts = {
        brand: cardBrand,
        cardNumber: cardNumber,
        cvv: cardCVV,
        expirationMonth: cardValidityMonth,
        expirationYear: cardValidityYear,
        success: function (response) {
          console.log(response.card.token);
          $cardToken.val(response.card.token);
          enableOrderBtn();
        },
        error: function (response) {
          console.log(response);
          enableOrderBtn();
          showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
        },
      };
      PagSeguroDirectPayment.createCardToken(opts);
    }
  }

  // ------------------------------------
  // Mercado Pago
  // ------------------------------------

  // Inicia o Mercado Pago
  if (typeof Mercadopago != 'undefined' && !previewMode) {
    initMercadopago();
  }
  function initMercadopago() {
    getMercadoPagoToken();
  }

  // Obtém o token
  function getMercadoPagoToken() {
    const urlSession = urlBase + 'core/acoes/checkout/mercadopago_get_session.php';
    $.getJSON(
      `${urlSession}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      function (result) {
        //console.log(result);
        Mercadopago.setPublishableKey(result.mp_token);
        $formAddParams.append(
          `<select id="docType" name="docType" data-checkout="docType" type="text" class="form-input-hidden"></select>`,
        );
        /* $formAddParams.append(
          `<select id="issuer" name="issuer" data-checkout="issuer" class="form-input-hidden"></select>`,
        ); */
        $formAddParams.append(`<input type="hidden" id="paymentMethodId">`);
        Mercadopago.getIdentificationTypes();
      },
    ).fail(function (result) {
      console.log(result);
    });
  }

  // Seta o método de pagamento
  function setMercadoPagoPaymentMethod() {
    const cardBin = cardNumber.substring(0, 6);
    Mercadopago.getPaymentMethod(
      {
        bin: cardBin,
      },
      function (status, response) {
        if (status == 200) {
          //console.log(response);
          hideCardNumberError();
          let paymentMethod = response[0];
          $cardBrand.val(paymentMethod.id);
          $('#paymentMethodId').val(paymentMethod.id);
          getMercadoPagoInstallments(cardBin, getTotalCheckout());
          //getMercadoPagoIssuers(paymentMethod.id);
        } else {
          console.log(response);
          showCardNumberError();
        }
      },
    );
  }

  // Obtém os bancos
  function getMercadoPagoIssuers(paymentMethodId) {
    Mercadopago.getIssuers(paymentMethodId, function (status, response) {
      if (status == 200) {
        //console.log(response);
        let $issuerSelect = $('#issuer');
        response.forEach((issuer) => {
          let opt = document.createElement('option');
          opt.text = issuer.name;
          opt.value = issuer.id;
          $issuerSelect.append(opt);
        });
        getMercadoPagoInstallments($('#paymentMethodId').val(), getTotalCheckout(), $issuerSelect.val());
      } else {
        console.log(response);
      }
    });
  }

  // Obtém as parcelas do cartão
  //function getMercadoPagoInstallments(paymentMethodId, transactionAmount, issuerId) {
  function getMercadoPagoInstallments(cardBin, transactionAmount) {
    Mercadopago.getInstallments(
      /* {
        payment_method_id: paymentMethodId,
        amount: parseFloat(transactionAmount),
        issuer_id: parseInt(issuerId),
      }, */
      {
        bin: cardBin,
        amount: parseFloat(transactionAmount),
      },
      function (status, response) {
        if (status == 200) {
          //console.log(response);
          let installments = response[0].payer_costs;
          // Formata as parcelas para o formato utilizado
          let newInstallments = [];
          installments.forEach((item) => {
            newInstallments.push({
              installment: item.installments,
              amount: item.total_amount,
              interestFree: item.installment_rate === 0,
              installment_amount: item.installment_amount,
            });
          });
          installments = newInstallments;
          saveInstallments(installments);
          populeInstallments(installments);
        } else {
          console.log(response);
        }
      },
    );
  }

  // Obtém o token do cartão
  function getMercadoPagoCardToken() {
    if (validateCardInfos() && $cardCPF.val() != '') {
      disableOrderBtn();
      try {
        Mercadopago.createToken($form[0], function (status, response) {
          enableOrderBtn();
          if (status == 200 || status == 201) {
            //console.log(response);
            hideCardNumberError();
            $cardToken.val(response.id);
          } else {
            console.log(response);
            if (response.cause[0].code === 'E301') {
              showCardNumberError();
            } else {
              showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
            }
          }
        });
      } catch (error) {
        console.log(error);
        enableOrderBtn();
      }
    }
  }

  // ------------------------------------
  // Pagarme
  // ------------------------------------

  // Inicia o Pagarme
  if (typeof pagarme != 'undefined' && !previewMode) {
    initPagarme();
  }
  function initPagarme() {
    getPagarmeToken();
  }

  // Obtém o token
  function getPagarmeToken() {
    const urlSession = urlBase + 'core/acoes/checkout/pagarme_get_session.php';
    $.getJSON(
      `${urlSession}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      function (result) {
        console.log(result);
        pagarme._token = result.token;
        if (result.version == 'v5') {
          pagarme._version = result.version;
        }
      },
    ).fail(function (result) {
      console.log(result);
    });
  }

  // Obtém o token do cartão
  function getPagarmeCardToken() {
    if (timerToken) {
      clearInterval(timerToken);
    }
    const cardName = $cardName.val();
    const cardCVV = $cardCVV.val();
    if (cardNumber && cardName && cardValidityMonth && cardValidityYear && cardCVV.length >= 3) {
      // Gera o token para a api V4
      if (!pagarme._version || pagarme._version == 'v4') {
        const expiration =
          cardValidityMonth && cardValidityYear ? cardValidityMonth + '/' + cardValidityYear.substring(2) : false;
        const card = {
          card_number: cardNumber,
          card_holder_name: cardName,
          card_expiration_date: expiration,
          card_cvv: cardCVV,
        };
        const cardValidations = pagarme.validate({ card: card });
        if (cardValidations.card.card_number) {
          disableOrderBtn();
          hideCardNumberError();
          $cardBrand.val(cardValidations.card.brand);
          pagarme.client
            .connect({ encryption_key: pagarme._token })
            .then((client) => client.security.encrypt(card))
            .then((card_hash) => {
              //console.log(card_hash);
              $cardToken.val(card_hash);
              enableOrderBtn();
            });
        } else {
          enableOrderBtn();
          console.log(cardValidations);
          showCardNumberError();
        }
      }
      // Gera o token para a api V5
      if (pagarme._version == 'v5') {
        const card = {
          number: cardNumber,
          holder_name: cardName,
          exp_month: Number(cardValidityMonth),
          exp_year: Number(cardValidityYear.substring(2)),
          cvv: cardCVV,
          label: '',
        };
        function fetchTokenV5() {
          disableOrderBtn();
          const url = urlBase + 'core/acoes/checkout/pagarme_get_card_token.php';
          fetch(url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              api_token: pagarme._token,
              data: {
                type: 'card',
                card: card,
              },
            }),
          })
            .then((res) => res.json())
            .then((res) => {
              console.log(res);
              enableOrderBtn();
              if (res.token_card) {
                $cardToken.val(res.token_card);
              } else {
                showCardNumberError();
              }
            });
        }
        fetchTokenV5();
        timerToken = setInterval(fetchTokenV5, 30000);
      }
    }
  }

  // ------------------------------------
  // Appmax
  // ------------------------------------

  // Obtém o token do cartão
  function getAppmaxCardToken() {
    if (timerToken) {
      clearInterval(timerToken);
    }
    if (validateCardInfos(false)) {
      function fetchToken() {
        console.log('Fetch token appmax...');
        disableOrderBtn();
        const cardName = $cardName.val();
        const cardCVV = $cardCVV.val();
        const cardMonth = Number(cardValidityMonth);
        const cardYear = cardValidityYear.substring(2);
        const data = {
          name: cardName,
          number: cardNumber,
          cvv: cardCVV,
          month: cardMonth,
          year: cardYear,
        };
        const url = urlBase + 'core/acoes/checkout/appmax_get_card_token.php';
        $.getJSON(
          `${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
          data,
          function (result) {
            console.log(result);
            if (result.card_token) {
              $cardToken.val(result.card_token);
              enableOrderBtn();
            } else {
              showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
            }
          },
        ).fail(function (result) {
          console.log(result);
          enableOrderBtn();
          showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
        });
      }
      fetchToken();
      timerToken = setInterval(fetchToken, 30000);
    }
  }

  // ------------------------------------
  // Cielo
  // ------------------------------------

  // Obtém o token do cartão
  function getCieloCardToken() {
    if (validateCardInfos(false)) {
      disableOrderBtn();
      const cardName = $cardName.val();
      const cardCustomer = $cardCustomer.val();
      const cardBrand = $cardBrand.val();
      const cardMonth = Number(cardValidityMonth);
      const cardYear = cardValidityYear;
      const data = {
        name: cardName,
        number: cardNumber,
        month: cardMonth,
        year: cardYear,
        customer: cardCustomer,
        brand: cardBrand,
      };
      const url = urlBase + 'core/acoes/checkout/cielo_get_card_token.php';
      $.getJSON(
        `${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
        data,
        function (result) {
          console.log(result);
          $cardToken.val(result.card_token);
          enableOrderBtn();
        },
      ).fail(function (result) {
        console.log(result);
        enableOrderBtn();
        showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
      });
    }
  }
  // Obtém dados do cartão via BIN
  function getCieloCardBin() {
    const cardBin = cardNumber.substring(0, 6);
    const data = {
      bin: cardBin,
    };
    const url = urlBase + 'core/acoes/checkout/cielo_get_card_bin.php';
    $.getJSON(
      `${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      data,
      function (result) {
        console.log(result);
        $cardBrand.val(result.card_bin.Provider);
        return result;
      },
    ).fail(function (result) {
      console.log(result);
      showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
    });
  }

  // ------------------------------------
  // Rede
  // ------------------------------------

  // Obtém o token do cartão
  function getRedeCardToken() {
    if (validateCardInfos(false)) {
      disableOrderBtn();
      const cardName = $cardName.val();
      const cardCustomer = $cardCustomer.val();
      const cardBrand = $cardBrand.val();
      const cardMonth = Number(cardValidityMonth);
      const cardYear = cardValidityYear;
      const cardCVV = $cardCVV.val();
      const data = {
        name: cardName,
        number: cardNumber,
        month: cardMonth,
        year: cardYear,
        customer: cardCustomer,
        brand: cardBrand,
        cvv: cardCVV,
      };
      const url = urlBase + 'core/acoes/checkout/rede_get_card_token.php';
      $.getJSON(
        `${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
        data,
        function (result) {
          console.log(result);
          $cardToken.val(result.card_token);
          enableOrderBtn();
        },
      ).fail(function (result) {
        console.log(result);
        enableOrderBtn();
        showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
      });
    }
  }

  // ------------------------------------
  // Doppus
  // ------------------------------------

  function getDoppusCardToken() {
    if (validateCardInfos(false)) {
      disableOrderBtn();
      const cardName = $cardName.val();
      const cardCustomer = $cardCustomer.val();
      const cardBrand = $cardBrand.val();
      const cardMonth = Number(cardValidityMonth);
      const cardYear = cardValidityYear;
      const cardCVV = $cardCVV.val();
      const data = {
        name: cardName,
        number: cardNumber,
        month: cardMonth,
        year: cardYear,
        customer: cardCustomer,
        brand: cardBrand,
        cvv: cardCVV,
      };
      const url = urlBase + 'core/acoes/checkout/doppus_get_card_token.php';
      $.getJSON(
        `${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
        data,
        function (result) {
          console.log(result);
          $cardToken.val(result.card_token);
          enableOrderBtn();
        },
      ).fail(function (result) {
        console.log(result);
        enableOrderBtn();
        showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
      });
    }
  }

  // ------------------------------------
  // Abmex
  // ------------------------------------

  // Inicia
  if (typeof AbmexPay != 'undefined' && !previewMode) {
    initAbmex();
  }
  function initAbmex() {
    getAbmexToken();
  }

  // Obtém o token da api
  function getAbmexToken() {
    const urlSession = urlBase + 'core/acoes/checkout/abmex_get_session.php';
    $.getJSON(
      `${urlSession}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
      function (result) {
        //console.log(result);
        if (result.token) {
          AbmexPay.setPublicKey(result.token);
          //AbmexPay.setTestMode(true);
        } else {
          console.log('Não foi possível obter o token de api da Abmex.');
        }
      },
    ).fail(function (result) {
      console.log(result);
    });
  }

  // Obtém o token do cartão
  function getAbmexCardToken() {
    if (validateCardInfos(false)) {
      disableOrderBtn();
      const cardName = $cardName.val();
      const cardMonth = Number(cardValidityMonth);
      const cardYear = cardValidityYear;
      const cardCVV = $cardCVV.val();
      const data = {
        number: cardNumber,
        holderName: cardName,
        expMonth: cardMonth,
        expYear: cardYear,
        cvv: cardCVV,
      };
      AbmexPay.encrypt(data)
        .then((cartToken) => {
          console.log('cardToken: ', cartToken);
          $cardToken.val(cartToken);
          enableOrderBtn();
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  // ------------------------------------
  // PAGOU AI
  // ------------------------------------

  // Inicia o Pagou ai
  if (typeof Pagou != 'undefined' && !previewMode) {
    initPagouai();
  }
  function initPagouai() {
    getPagouaiToken();
  }

  // Obtém o token
  function getPagouaiToken() {
    const urlSession = urlBase + 'core/acoes/checkout/pagouai_get_session.php';
    $.getJSON(`${urlSession}?store_token=${storeToken}`, function (result) {
      console.log(result);
      Pagou.setPublicKey(result.token);
      //HopyPay.setTestMode(true);
    }).fail(function (result) {
      console.log(result);
    });
  }

  // Obtém o token do cartão
  function getPagouaiCardToken() {
    if (validateCardInfos(false)) {
      disableOrderBtn();
      const cardName = $cardName.val();
      const cardMonth = Number(cardValidityMonth);
      const cardYear = cardValidityYear;
      const cardCVV = $cardCVV.val();
      const data = {
        number: cardNumber,
        holderName: cardName,
        expMonth: cardMonth,
        expYear: cardYear,
        cvv: cardCVV,
      };
      Pagou.encrypt(data)
        .then((cartToken) => {
          console.log('cardToken: ', cartToken);
          $cardToken.val(cartToken);
          enableOrderBtn();
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  // ------------------------------------
  // DOM
  // ------------------------------------

  // Inicia o Dom
  if (typeof DomPagamentos != 'undefined' && !previewMode) {
    initDom();
  }
  function initDom() {
    getDomToken();
  }

  // Obtém o token
  function getDomToken() {
    const urlSession = urlBase + 'core/acoes/checkout/dom_get_session.php';
    $.getJSON(`${urlSession}?store_token=${storeToken}`, function (result) {
      console.log(result);
      DomPagamentos.setPublicKey(result.token);
      window.DomVersion = result.version || 2;
      //HopyPay.setTestMode(true);
    }).fail(function (result) {
      console.log(result);
    });
  }

  // Obtém o token do cartão
  function getDomCardToken() {
    if (window.DomVersion == 3) {
      getDomCardTokenV3();
    } else {
      if (validateCardInfos(false)) {
        disableOrderBtn();
        const cardName = $cardName.val();
        const cardMonth = Number(cardValidityMonth);
        const cardYear = cardValidityYear;
        const cardCVV = $cardCVV.val();
        const data = {
          number: cardNumber,
          holderName: cardName,
          expMonth: cardMonth,
          expYear: cardYear,
          cvv: cardCVV,
        };
        DomPagamentos.encrypt(data)
          .then((cartToken) => {
            console.log('cardToken: ', cartToken);
            $cardToken.val(cartToken);
            enableOrderBtn();
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  }

  // ------------------------------------
  // DOM V3
  // ------------------------------------

  // Inicia o Dom
  if (typeof initTokenCard !== 'undefined' && !previewMode) {
    initDomV3();
  }
  function initDomV3() {
    getDomTokenV3();
  }

  // Obtém o token
  function getDomTokenV3() {
    const urlSession = urlBase + 'core/acoes/checkout/dom_get_session.php';
    $.getJSON(`${urlSession}?store_token=${storeToken}`, function (result) {
      //console.log(result);
      window.DomPublicKey = result.token;
      window.DomVersion = 3;
      // Cria o formulário
      $('.checkout-pag').append(`
      <form id="dompag-form" action="#" method="POST">
        <input type="hidden" data-dompag="number">
        <input type="hidden" data-dompag="verification_value">
        <input type="hidden" data-dompag="full_name">
        <input type="hidden" data-dompag="expiration">
        <input type="hidden" data-dompag="document">
        <input type="hidden" data-dompag="phone">
        <input type="hidden" data-dompag="installments">
        <input type="hidden" data-dompag="token-card">
        <input type="hidden" data-dompag="brand-card">
        <input type="hidden" data-dompag="bin-card">
      </form>`);
      $('#form-checkout').append('<input type="hidden" name="card_bin" id="co-card-bin">');
      $('#co-card-installments').on('change', getDomCardTokenV3);
    }).fail(function (result) {
      console.log(result);
    });
  }

  // Obtém o token do cartão
  function getDomCardTokenV3() {
    if (validateCardInfos(false) && $('#co-card-installments').val() && $cardCPF.val() != '') {
      disableOrderBtn();
      let data_card = {
        name: $cardName.val(),
        document: somenteNumeros($cardCPF.val()),
        number: cardNumber,
        cvv: $cardCVV.val(),
        month: cardValidityMonth,
        year: cardValidityYear.substring(2),
      };
      let installments = $installments.val() || 1;
      getTokenCard(window.DomPublicKey, data_card, installments, function (data) {
        console.log(data);
        enableOrderBtn();
        if (data.token) {
          $cardToken.val(data.token);
          $cardBrand.val(data.brand);
          $('#co-card-bin').val(data.bin);
        } else {
          console.log('ERRO: ' + data.msgError);
        }
      });
      /* $('#dompag-form input[data-dompag="number"]').val(cardNumber);
      $('#dompag-form input[data-dompag="verification_value"]').val($cardCVV.val());
      $('#dompag-form input[data-dompag="full_name"]').val($cardName.val());
      $('#dompag-form input[data-dompag="expiration"]').val($cardValidity.val());
      $('#dompag-form input[data-dompag="document"]').val($cardCPF.val());
      $('#dompag-form input[data-dompag="phone"]').val($('#co-phone').val());
      $('#dompag-form input[data-dompag="installments"]').val($('#co-card-installments').val());
      initTokenCard(window.DomPublicKey, 'dompag-form', function (data) {
        console.log(data);
        enableOrderBtn();
        if (data.token) {
          $cardToken.val(data.token);
          $cardBrand.val(data.brand);
          $('#co-card-bin').val(data.bin);
        } else {
          console.log('ERRO: ' + data.msgError);
        }
      }); */
    }
  }

  // ------------------------------------
  // Cloudfox
  // ------------------------------------

  // Obtém o token do cartão
  function getCloudfoxCardToken() {
    if (validateCardInfos(false)) {
      getCloudfoxAntifraudToken();
      disableOrderBtn();
      const cardName = $cardName.val();
      const cardCustomer = $cardCustomer.val();
      const cardBrand = $cardBrand.val();
      const cardMonth = Number(cardValidityMonth);
      const cardYear = cardValidityYear;
      const cardCVV = $cardCVV.val();
      const data = {
        name: cardName,
        number: cardNumber,
        month: cardMonth,
        year: cardYear,
        customer: cardCustomer,
        brand: cardBrand,
        cvv: cardCVV,
      };
      const url = urlBase + 'core/acoes/checkout/cloudfox_get_card_token.php';
      $.getJSON(
        `${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
        data,
        function (result) {
          console.log(result);
          $cardToken.val(result.card_token);
          enableOrderBtn();
        },
      ).fail(function (result) {
        console.log(result);
        enableOrderBtn();
        showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
      });
    }
  }

  // Obtém o token do cartão
  function getNexusCardToken() {
    if (validateCardInfos(false)) {
      getCloudfoxAntifraudToken();
      disableOrderBtn();
      const cardName = $cardName.val();
      const cardCustomer = $cardCustomer.val();
      const cardBrand = $cardBrand.val();
      const cardMonth = Number(cardValidityMonth);
      const cardYear = cardValidityYear;
      const cardCVV = $cardCVV.val();
      const data = {
        name: cardName,
        number: cardNumber,
        month: cardMonth,
        year: cardYear,
        customer: cardCustomer,
        brand: cardBrand,
        cvv: cardCVV,
      };
      const url = urlBase + 'core/acoes/checkout/nexus_get_card_token.php';
      $.getJSON(
        `${url}?cart_token=${cartToken}&product=${productUrl}&store_token=${storeToken}`,
        data,
        function (result) {
          console.log(result);
          $cardToken.val(result.card_token);
          enableOrderBtn();
        },
      ).fail(function (result) {
        console.log(result);
        enableOrderBtn();
        showAlert('Erro', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
      });
    }
  }

  // Carrega o script da antifraude
  /* if (typeof CloudfoxAntifraud != 'undefined' && !previewMode) {
    let sensitiveFields = ['co-card-name', 'co-card-number', 'co-card-validity', 'co-card-cvv'];
    let secretFields = [''];
    if (CloudfoxAntifraud.script.readyState) {
      // Internet Explorer
      script.onreadystatechange = function () {
        if (CloudfoxAntifraud.script.readyState == 'loaded' || CloudfoxAntifraud.script.readyState == 'complete') {
          CloudfoxAntifraud.script.onreadystatechange = null;
          CloudfoxAntifraud.initAntifraud(sensitiveFields, secretFields);
        }
      };
    } else {
      // Outros Navegadores
      CloudfoxAntifraud.script.onload = function () {
        console.log('CloudfoxAntifraud loaded');
        CloudfoxAntifraud.initAntifraud(sensitiveFields, secretFields);
      };
    }
  } */

  // Obtém o código do antifraude
  /* function getCloudfoxAntifraudToken() {
    if (typeof CloudfoxAntifraud != 'undefined') {
      if (window.dftp) {
        dftp.profile(() => {
          const attemptReference = CloudfoxAntifraud.getAttemptReference();
          if ($formAddParams.find('[name="attempt_reference"]').length > 0) {
            $formAddParams.find('[name="attempt_reference"]').val(attemptReference);
          } else {
            $formAddParams.append(`<input type="hidden" name="attempt_reference" value="${attemptReference}">`);
          }
          console.log(attemptReference);
        });
      } else {
        console.log('Não foi possível obter o código do antifraude.');
      }
    }
  } */

  // Carrega o script do antifraude
  const cfScript = document.getElementById('cfScript');
  if (cfScript !== null && !previewMode) {
    let sensitiveFields = ['co-card-name', 'co-card-number', 'co-card-validity', 'co-card-cvv'];
    let secretFields = [''];
    if (cfScript.readyState) {
      // IE
      cfScript.onreadystatechange = function () {
        if (cfScript.readyState == 'loaded' || cfScript.readyState == 'complete') {
          cfScript.onreadystatechange = null;
          cfa.init(sensitiveFields, secretFields);
        }
      };
    } else {
      // Outros navegadores
      cfScript.onload = function () {
        cfa.init(sensitiveFields, secretFields);
      };
    }
  }

  // Obtém o código do antifraude
  function getCloudfoxAntifraudToken() {
    if (typeof cfa != 'undefined') {
      if (window.cfa) {
        cfa.profile(() => {
          const attemptReference = cfa.getAttemptReference();
          if ($formAddParams.find('[name="attempt_reference"]').length > 0) {
            $formAddParams.find('[name="attempt_reference"]').val(attemptReference);
          } else {
            $formAddParams.append(`<input type="hidden" name="attempt_reference" value="${attemptReference}">`);
          }
          console.log('Antifraud token:' + attemptReference);
        });
      } else {
        console.log('Não foi possível obter o código do antifraude.');
      }
    }
  }

  // ------------------------------------
  // IUGU
  // ------------------------------------

  // Inicia o Iugu
  if (typeof Iugu != 'undefined' && !previewMode) {
    if (window.LPQV.gateways?.iugu?.public_key) {
      Iugu.setAccountID(window.LPQV.gateways.iugu.public_key);
      console.log(window.LPQV.gateways.iugu.public_key);
    }
    if (window.LPQV.gateways?.tryplopay?.public_key) {
      Iugu.setAccountID(window.LPQV.gateways.tryplopay.public_key);
      console.log(window.LPQV.gateways.tryplopay.public_key);
    }
  }

  // Obtém o token do cartão
  function getIuguCardToken() {
    if (timerToken) {
      clearInterval(timerToken);
    }
    if (validateCardInfos(false)) {
      disableOrderBtn();
      const cardName = $cardName.val();
      const cardMonth = cardValidityMonth;
      const cardYear = cardValidityYear;
      const cardCVV = $cardCVV.val();
      const nameArr = cardName.trim().split(' ');
      const firstName = nameArr[0];
      nameArr.shift();
      const lastName = nameArr.join(' ');
      const ccIugu = Iugu.CreditCard(cardNumber, cardMonth, cardYear, firstName, lastName, cardCVV);
      function fetchIuguCardToken() {
        Iugu.createPaymentToken(ccIugu, function (response) {
          if (response.errors) {
            console.log(response);
            showAlert('Cartão inválido', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
            enableOrderBtn();
          } else {
            console.log('cardToken: ', response.id);
            $cardToken.val(response.id);
            enableOrderBtn();
          }
        });
      }
      fetchIuguCardToken();
      timerToken = setInterval(fetchIuguCardToken, 5000);
    }
  }

  // ------------------------------------
  // GETNET
  // ------------------------------------

  // Variáveis
  const getnetApi = `${urlBase}core/acoes/checkout/getnet.php?store_token=${storeToken}&cart_token=${cartToken}`;
  let getnetToken = null;

  // Obtém o token de acesso
  function getnetAuthToken() {
    $.getJSON(`${getnetApi}&acao=auth_token`, function (result) {
      if (result.status === 'success') {
        getnetToken = result.auth_token;
      } else {
        console.log(result);
      }
    }).fail(function (result) {
      console.log(result);
    });
  }
  if ($('#co_payment_method_credit_card').data('gateway') === 'getnet') {
    getnetAuthToken();
  }

  // Obtém o token do cartão
  function getNetCardToken() {
    if (validateCardInfos(false)) {
      let cardData = {
        card_number: cardNumber,
        cardholder_name: $cardName.val(),
        expiration_month: cardValidityMonth,
        expiration_year: cardValidityYear.substring(2),
        card_cvv: $cardCVV.val(),
      };
      cardData = objToQueryString(cardData);
      disableOrderBtn();
      $.getJSON(`${getnetApi}&acao=card_token&auth_token=${getnetToken}&${cardData}`, function (result) {
        enableOrderBtn();
        if (result.status === 'success' && result.card_token) {
          console.log('cardToken: ', result.card_token);
          $cardToken.val(result.card_token);
          $('#getnet_customer_id').val(result.customer_id);
          if (result.card_verify.status === 'VERIFIED') {
            console.log('Cartão VERIFICADO!');
          } else {
            console.log(result);
            //showAlert('Cartão inválido', 'Por favor, revise os dados do cartão e tente novemente.', 'danger');
          }
        }
      }).fail(function (result) {
        console.log(result);
        enableOrderBtn();
      });
    }
  }
})();
